
import { mapGetters } from 'vuex'
export default {
    props: {
        item: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {}
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo'
        })
    },
    mounted () { },
    methods: {
        async onBuy () {
            const { goodsNo } = this.item.content.content
            const par = {
                action: {
                    goodsNo
                }
            }
            // 判断商品状态
            const res = await this.$api.orderUpdatePriceAPI(par)
            if (!res.success) {
                return this.$message.error(res.info)
            }
            const res1 = await this.$api.goodsDetails({
                action: {
                    goodsNo
                }
            })
            if (!res1.success) {
                return this.$message.error(res1.info)
            }
            if (res1.data.status !== 'TRADING' && res1.data.status !== 'ON_STAND') {
                return this.$message.error('商品不处于上架状态，请联系客服协助处理！')
            }
            const query = {
                goodsNo: this.item.content.content.goodsNo,
                goodsCatalogueId: this.item.content.content.goodsCatalogueId || 6,
                orderType: 'orderUpdatePricePay',
                status: 'null',
                oldOrderNo: this.item.content.content.oldOrderNo,
                modifyPrice: res.data.price
            }
            // success:true 就让它通过
            this.$router.push({
                path: '/confirmOrder/fullPayment',
                query
            })
        }
    }
}
